module.exports = __webpack_public_path__ + "media/src/images/abouts/icons/twitter-ef347670130a5b9b5bc6a512ddeaa9c9.svg";